import { createElement } from 'react';
import { Box } from '@alifd/next';
import './index.scss';
const OadpIframe = function OadpIframe({ name, src, page, style, ...otherProps }) {
    if (page) {
        src = 'http://localhost:5556/preview.html?pageId=' + page + '&scenarioName=11eda2938d9ef330b49bf7f609a49999';
    }
    return (createElement(Box, Object.assign({}, otherProps),
        createElement("iframe", { name: name || '', style: style || {
                width: '100%',
                height: '500px',
            }, src: src || '' })));
};
export default OadpIframe;
